 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"business-pulse":"business-pulse","super-admin-legal-documents":"super-admin-legal-documents","help-center":"help-center","super-admin-audit":"super-admin-audit","super-admin-sessions":"super-admin-sessions","pulse-engine":"pulse-engine","odontogram-co26-capture":"odontogram-co26-capture"}[chunkId]||chunkId) + "." + {"business-pulse":"c564e7ed","chunk-067b8c0c":"05464eed","chunk-14db9968":"9a3345c3","chunk-28657390":"cb6958e7","chunk-fc7d6c3a":"11cd517f","chunk-8fb9d06c":"269a0501","chunk-2d0b309a":"f07b1568","chunk-2d208717":"70e7a30b","chunk-2d20f987":"d7cd3475","chunk-2d21025a":"2e364536","chunk-2d216214":"11b85764","chunk-457476e2":"a9a37f28","chunk-5d2b8c81":"194f61e0","chunk-b0bac730":"702109e6","chunk-dc17dae0":"b6231f5e","super-admin-legal-documents":"8dd422ac","chunk-37dad54c":"c9156a48","chunk-3b233e96":"719ac191","chunk-2741efc8":"a097809c","chunk-60154c1d":"dcf22447","chunk-62d07095":"a3db10fd","chunk-6f3fe0aa":"bdf4ece7","chunk-6f54caed":"adba9d35","chunk-a52062b8":"ca9e70fe","chunk-d11bcdc0":"c5c9d7cc","chunk-e5f7ff78":"86105563","chunk-f4d4031c":"fc23cec7","chunk-56f25e0b":"f4519184","chunk-fb2d5150":"00457c11","help-center":"f9c7c62f","super-admin-audit":"1000d3ca","super-admin-sessions":"0d1e209e","pulse-engine":"171a1660","chunk-689f976a":"79dba014","chunk-752f5c32":"8de5172d","chunk-2d219fe4":"e4a1b3fb","chunk-2d22c495":"fe8e2636","chunk-4ebe3e0e":"e2e17091","chunk-66baee62":"5fbb8f9a","chunk-74a75766":"ae76cdb0","chunk-8b5b4a22":"b8a15561","chunk-d3bdff9a":"f94f0d9c","chunk-fd3a0892":"8cd1543b","chunk-4f30be16":"ecff2e9a","chunk-88ac1ae0":"faf5c8ff","chunk-443ee071":"573425e3","chunk-d8b49120":"f55a379b","chunk-1a0ed924":"aafc5a28","chunk-77e9da92":"f84fb8b0","odontogram-co26-capture":"ab421204"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"business-pulse":1,"chunk-067b8c0c":1,"chunk-14db9968":1,"chunk-28657390":1,"chunk-fc7d6c3a":1,"chunk-8fb9d06c":1,"chunk-457476e2":1,"chunk-5d2b8c81":1,"chunk-b0bac730":1,"chunk-dc17dae0":1,"super-admin-legal-documents":1,"chunk-37dad54c":1,"chunk-3b233e96":1,"chunk-2741efc8":1,"chunk-60154c1d":1,"chunk-62d07095":1,"chunk-6f3fe0aa":1,"chunk-6f54caed":1,"chunk-a52062b8":1,"chunk-d11bcdc0":1,"chunk-e5f7ff78":1,"chunk-f4d4031c":1,"chunk-56f25e0b":1,"chunk-fb2d5150":1,"help-center":1,"super-admin-audit":1,"super-admin-sessions":1,"chunk-689f976a":1,"chunk-752f5c32":1,"chunk-4ebe3e0e":1,"chunk-66baee62":1,"chunk-74a75766":1,"chunk-d3bdff9a":1,"chunk-fd3a0892":1,"chunk-4f30be16":1,"chunk-88ac1ae0":1,"chunk-443ee071":1,"chunk-d8b49120":1,"chunk-1a0ed924":1,"chunk-77e9da92":1,"odontogram-co26-capture":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"business-pulse":"business-pulse","super-admin-legal-documents":"super-admin-legal-documents","help-center":"help-center","super-admin-audit":"super-admin-audit","super-admin-sessions":"super-admin-sessions","pulse-engine":"pulse-engine","odontogram-co26-capture":"odontogram-co26-capture"}[chunkId]||chunkId) + "." + {"business-pulse":"ae783590","chunk-067b8c0c":"4381303d","chunk-14db9968":"615b14f7","chunk-28657390":"55cd46ea","chunk-fc7d6c3a":"a54c7d4e","chunk-8fb9d06c":"00f4ad35","chunk-2d0b309a":"31d6cfe0","chunk-2d208717":"31d6cfe0","chunk-2d20f987":"31d6cfe0","chunk-2d21025a":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-457476e2":"f4de223e","chunk-5d2b8c81":"8f293dde","chunk-b0bac730":"6e0998ba","chunk-dc17dae0":"e22f20bb","super-admin-legal-documents":"47dfaa7b","chunk-37dad54c":"866ab9a8","chunk-3b233e96":"fd288dd0","chunk-2741efc8":"cfbac3a2","chunk-60154c1d":"a8634a9a","chunk-62d07095":"47870f4f","chunk-6f3fe0aa":"61182dfe","chunk-6f54caed":"1ce1082b","chunk-a52062b8":"02675a7b","chunk-d11bcdc0":"1a1231ba","chunk-e5f7ff78":"47cfbb2b","chunk-f4d4031c":"5707e0c7","chunk-56f25e0b":"749891a3","chunk-fb2d5150":"f8d9c13e","help-center":"82e1dfc4","super-admin-audit":"a34aea76","super-admin-sessions":"00aa7e1c","pulse-engine":"31d6cfe0","chunk-689f976a":"ac2690c6","chunk-752f5c32":"94d7d633","chunk-2d219fe4":"31d6cfe0","chunk-2d22c495":"31d6cfe0","chunk-4ebe3e0e":"6cd5b20e","chunk-66baee62":"5c68bd8a","chunk-74a75766":"369a3dea","chunk-8b5b4a22":"31d6cfe0","chunk-d3bdff9a":"fb80f017","chunk-fd3a0892":"e1d1e697","chunk-4f30be16":"d99aad68","chunk-88ac1ae0":"d4841698","chunk-443ee071":"a157e275","chunk-d8b49120":"bc572137","chunk-1a0ed924":"08f553b2","chunk-77e9da92":"a09ee855","odontogram-co26-capture":"ddbb345b"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
